import { Breakpoint, Color, Markdown, ZIndex } from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { MobileImageProps } from './accountSetupFrame.types';

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 100vh;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: row;
    height: 100vh;
  }
`;

export const RightWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const TopBar = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 16px;
  border-bottom: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${ZIndex.Min};

  @media ${Breakpoint.SmallDesktop} {
    padding: 24px 40px;
    position: static;
    border-bottom: 1px solid ${Color.Gray300};
  }
`;

export const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 0;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: row;
  }
`;

export const LogoWrapper = styled.button`
  border: none;
  background-color: ${Color.Transparent};
  padding: 0;
`;

export const Logo = styled.img`
  display: block;
  height: 28px;

  @media ${Breakpoint.Tablet} {
    height: 32px;
  }
`;

export const DesktopImage = styled.img`
  width: 50%;
  max-width: 640px;
  min-height: 0;
  object-fit: cover;
  object-position: center;
`;

export const MobileImage = styled.div<MobileImageProps>`
  ${({ $image }: MobileImageProps): string => `background-image: url(${$image})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center bottom;
  aspect-ratio: 375 / 200;
  width: 100%;
  position: relative;
`;

export const ChildrenWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BottomBar = styled.div`
  padding: 24px 16px;
  border-top: 1px solid ${Color.Gray300};
  display: flex;
  align-items: center;
  position: relative;
  bottom: 0;

  @media ${Breakpoint.SmallDesktop} {
    padding: 12px 40px;
    min-height: 80px;
    position: static;
  }
`;

export const DisclaimerText = styled(Markdown)`
  strong {
    color: ${Color.Gray800};
  }
`;
